import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { historyActions } from "../../store/history"

import classes from './HistoryFilters.module.css'
import InputBox from "../common/interactive/InputBox"
import RangeDatePickerFilter from "../work_queues/pages/custom/filters/RangeDatePickerFilter"
import CustomSelect from "../common/interactive/CustomSelect"
import Button from "../common/Button"
import { modelTypesSystem } from "../../lib/systemData"
import DatePickerWithLabelRanged from "../common/interactive/DatePickerWithLabelRanged"
import ExportHistory from "./ExportHistory"

export default function HistoryFilters({ showNgFilter }) {
    const dispatch = useDispatch()
    const selectedFilters = useSelector(state => state.history.filters)
    const allUsers = useSelector(state => state.user.allUsers)
    const loading = useSelector(state => state.history.loading)
    const [filtersValues, setFiltersValues] = useState(null)

    function mainSelectAction(value) {
        let update = {
            ...filtersValues
        }
        //need to expand the object and include name of the selected options!
        if (value?.data?.value?.constructor == Array) { // check if array   
            update[value.identifier.type] = value.options
        } else {
            update[value.identifier.type]= {
                value: value.data.value,
                item: value.option
            }

            if (value.data.value == null) {
                delete update[value.identifier.type]
            }
        }      

        setFiltersValues(update)

        // on change set filters....
        // on change set filters....
        dispatch(historyActions.setCurrentPage(1))
        dispatch(historyActions.setFiltersMultiple(update))
    }

    function clearAllFiltersHandler() {
        dispatch(historyActions.setFiltersMultiple({}))   
    }

    function setFiltersHandler(event) {
        dispatch(historyActions.setCurrentPage(1))
        dispatch(historyActions.setFiltersMultiple(filtersValues))
    }

    // set the filters from settings 
    useEffect(() => {
        let mergeTheSelectedFilters = {
            ...selectedFilters
        }
        setFiltersValues(mergeTheSelectedFilters)        
    }, [selectedFilters])

    return <div className={classes.master_filter}>
        {loading && <span className={`loader dark`}></span>}

        {/* <RangeDatePickerFilter preSelectedValue={filtersValues?.date?.value} action={mainSelectAction} identifier={{type: 'date', label: 'Date'}} /> */}
        <DatePickerWithLabelRanged preSelectedValue={filtersValues?.date?.value} action={mainSelectAction} identifier={{type: 'date', label: 'Date'}} />
        <CustomSelect label={"User"} optionsData={allUsers} preSelectedValue={filtersValues?.user?.value} action={mainSelectAction} name={'user'} identifier={{type: 'user', label: 'User'}}/>
        <CustomSelect label={"Area"} optionsData={modelTypesSystem()} preSelectedValue={filtersValues?.model_type?.value} action={mainSelectAction} name={'model_type'} identifier={{type: 'model_type', label: 'Area'}}/>
        {showNgFilter && <InputBox label={'NG #'} action={mainSelectAction} name={'ng_number'} currentValue={filtersValues?.ng_number?.value} identifier={{type: 'ng_number', label: 'NG #'}} setStyle={'bk_white'}/>}
        <InputBox label={'Message'} action={mainSelectAction} name={'search'} currentValue={filtersValues?.message?.value} identifier={{type: 'search', label: 'Message'}} setStyle={'bk_white'}/>
        {/* <Button click={setFiltersHandler}>Set Filters</Button>       */}
        <Button click={clearAllFiltersHandler} btnStyle={'btn_white'}>Clear</Button>    

        <ExportHistory />
    </div>
}